import { FunctionComponent } from "react";
import { IconButton, Tooltip, Typography } from "@mui/material";
import { PrintOutlined } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { managementTouchIconButtonSx } from "../utils/management-touch-target.styles";

type ManagementPrintButtonProps = {
  onPrint: () => void;
};

/**
 * Top-right Print to PDF control for Management report dashboards.
 */
export const ManagementPrintButton: FunctionComponent<ManagementPrintButtonProps> = ({
  onPrint
}) => {
  const { t } = useTranslation();
  const label = t("_management_printToPdf");

  return (
    <Tooltip title={<Typography>{label}</Typography>}>
      <IconButton
        size="small"
        onClick={onPrint}
        aria-label={label}
        data-testid="management-print-pdf"
        sx={managementTouchIconButtonSx}
      >
        <PrintOutlined fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
